const getViewFromContext = (state: any, path: string) => {
    const pathVarible = path.trim().split("/");
    if(pathVarible[1] == "private"){
        return state.privateViewState.findLast((e: any)=> e.id === +pathVarible[2])
    }else{
        return state.publicViewState.findLast((e: any)=> e.id === +pathVarible[2])
    }
}

export default getViewFromContext;